import { useSelector } from 'react-redux';

/**
 * Returns all editable enrichment questions
 * @param  {Number} eventId Event ID
 * @return {array}          Question list
 */

export function useAnswerableEnrichments(eventId) {
    return useSelector(state => _(state.events[eventId]?.enrichments.questions || [])
        .filter(q => {
            return q.question.category == 1;
        })
        .filter(question => {
            return question.question.editable || question.question.required;
        })
        .sortBy(question => question.number)
        .value()
    );
}
